/** Shared helpers for book / journal / marketplace authoring fields. */

export const linesToArray = (value) =>
  String(value || "")
    .split("\n")
    .map((entry) => entry.trim())
    .filter(Boolean);

export const arrayToLines = (value) => (Array.isArray(value) ? value.join("\n") : "");

export const stringifyTableOfContents = (value) => {
  if (!value) return "";
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return "";
  }
};

/**
 * Parse the table-of-contents textarea. Returns [] for an empty field and
 * throws a user-facing error when the JSON is invalid or not an array.
 */
export const parseTableOfContents = (value) => {
  const text = String(value || "").trim();
  if (!text) return [];
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw new Error("Table of contents must be valid JSON.");
  }
  if (!Array.isArray(parsed)) {
    throw new Error("Table of contents must be a JSON array.");
  }
  return parsed;
};

export const ACADEMIC_LEVELS = ["", "ND", "HND", "NCE", "BSC", "MSC", "PGD", "PHD", "OTHER"];
export const FILE_FORMATS = ["", "PDF", "DOCX", "OTHER"];
